@for (topic of topics$ | async; track trackTopic($index, topic)) {
  <app-training-category [topic]="topic"></app-training-category>
}
